import React, { useState } from "react";
import styled from "styled-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

/* Data ---------------------------*/
import Data2020 from "../assets/data/2020data";
import Data2021 from "../assets/data/2021data";
import Data2022 from "../assets/data/2022data";
import Data2023 from "../assets/data/2023data";
import Data2024 from "../assets/data/2024data";
import Data2025 from "../assets/data/2025data";
import Data2026 from "../assets/data/2026data";
import { tableSelect } from "../assets/data/selectData";

/* Components ---------------------------*/
import TaxTable from "../components/TaxTable/TaxTable";
import SelectButton from "../components/SelectButton/SelectButton";
import CapitalGains from "../components/MiscTables/CapitalGains";
import EarnedIncomeCredit from "../components/MiscTables/EarnedIncomeCredit";
import StandardDeduction from "../components/MiscTables/StandardDeduction";

const Federal = () => {
  const [selectedButton, selectedButtonUpdate] = useState(tableSelect[2]);

  const isMobile = navigator.maxTouchPoints > 0 ? "mview" : "dview";
  return (
    <FederalStyled className="Federal">
      <Container fluid className="g-0 mb-0">
        <div className="row g-0">
          <div className="hero-image">
            <h1>FEDERAL TAX RATE SCHEDULES</h1>
          </div>
        </div>
        <Tabs defaultIndex={1}>
          <div className="listParent">
            <TabList>
              <Tab>
                <strong>2026</strong>
              </Tab>
              <Tab>
                <strong>2025</strong>
              </Tab>
              <Tab>
                <strong>2024</strong>
              </Tab>
              <Tab>
                <strong>2023</strong>
              </Tab>
              <Tab>
                <strong>2022</strong>
              </Tab>
              <Tab>
                <strong>2021</strong>
              </Tab>
              <Tab>
                <strong>2020</strong>
              </Tab>
            </TabList>
          </div>
          <Container>
            <TabPanel>
              <h1 className="taxYear">2026 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://westerncpe.s3.us-east-1.amazonaws.com/tax-app/2026-FEDERAL-TAX-RATE-SCHEDULES.pdf"
                  target="blank"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF
                  </Button>
                </a>
              </div>
                <p className="Instructions">
                  <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-25-32.pdf" >Rev. Proc. 2025-32</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2026.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2026.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2026.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2026.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
              <StandardDeduction data={Data2026.Federal.Standard_Deduction} />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2025 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2026+Court+Cases/2025+Federal-California-Desk-Reference.pdf"
                  target="blank"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF
                  </Button>
                </a>
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href=" https://www.irs.gov/pub/irs-drop/rp-24-40.pdf" >Rev. Proc. 2024-40</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2025.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2025.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2025.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2025.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
              <StandardDeduction data={Data2025.Federal.Standard_Deduction} />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2024 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://www.westerncpe.com/wp-content/uploads/2024/11/2024-FEDERAL-TAX-RATE-SCHEDULES.pdf"
                  target="blank"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF
                  </Button>
                </a>
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-23-34.pdf" >Rev. Proc. 2023-34</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2024.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2024.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2024.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2024.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
              <StandardDeduction data={Data2024.Federal.Standard_Deduction} />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2023 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2023+FEDERAL+TAX+RATE+SCHEDULE+Final.pdf"
                  target="blank"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF{" "}
                  </Button>
                </a>
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-22-38.pdf" >Rev. Proc. 2022-38</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2023.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2023.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2023.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2023.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
              <StandardDeduction data={Data2023.Federal.Standard_Deduction} />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2022 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2022.pdf"
                  target="blank"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF
                  </Button>
                </a>
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-21-45.pdf" >Rev. Proc. 2021-45</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2022.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2022.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2022.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2022.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
              <StandardDeduction data={Data2022.Federal.Standard_Deduction} />
              <EarnedIncomeCredit />
              <CapitalGains data={Data2022.Federal.Capital_Gains} />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2021 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
                <a
                  href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2021+(UPDATED)+(1).pdf"
                  target="blank"
                  className="button"
                >
                  <Button type="submit" className="SelectButton">
                    <FontAwesomeIcon icon={faDownload} /> Download PDF
                  </Button>
                </a>
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-20-45.pdf" >Rev. Proc. 2020-45</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2021.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2021.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={
                  Data2021.Federal
                    .Married_Filing_Joint_and_Surviving_Spouse_with_Dependents
                }
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2021.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
            </TabPanel>
            <TabPanel>
              <h1 className="taxYear">2020 FEDERAL TAX RATE SCHEDULES</h1>
              <p className={`Instructions ${isMobile}`}>
                <em>
                  The buttons below allow you to select a single cell, row, or
                  the entire table and copy it to your clipboard.
                </em>
              </p>
              <div className="buttonGroup">
                <SelectButton
                  selectedButton={selectedButton}
                  selectedButtonUpdate={selectedButtonUpdate}
                  tableSelect={tableSelect}
                />
              </div>
              <p className="Instructions">
                <em>Tables made using data from IRS <a href="https://www.irs.gov/pub/irs-drop/rp-19-44.pdf">Rev. Proc. 2019-44</a></em>
                </p>
              <TaxTable
                title="Single"
                data={Data2020.Federal.Single}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Separate"
                data={Data2020.Federal.Married_Filing_Separate}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Married Filing Joint and Surviving Spouse with Dependents"
                data={Data2020.Federal.Married_Filing_Jointly}
                hover={selectedButton.name}
              />
              <TaxTable
                title="Unmarried Head of Household"
                data={Data2020.Federal.Unmarried_Head_of_Household}
                hover={selectedButton.name}
              />
            </TabPanel>
          </Container>
        </Tabs>
      </Container>
    </FederalStyled>
  );
};

export default Federal;

const FederalStyled = styled.div`
  h1 {
    text-align: center;
    padding-top: 50px;
  }

  h3 {
    text-align: center;
  }

  .hero-image {
    background-image: url("https://westerncpe.s3.amazonaws.com/tax-app/Group_145.jpg");
    height: 300px;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-bottom: 3px solid #00488e;
    h1 {
      text-align: center;
      color: white;
      margin: auto;
      padding-top: 125px;
    }
  }

  .full-width-div {
  }

  .react-tabs__tab-list {
    max-width: 1320px;
    margin: 0 auto;
    border-bottom: none;
  }

  .react-tabs__tab--selected {
    border-bottom: 2px solid #3ea8f4;
    border-top: none;
    border-right: none;
    border-left: none;
  }

  .react-tabs__tab:focus:after {
    background: none;
  }

  .listParent {
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
    background-color: #f8f9fb;
  }

  .mview {
    display: none;
  }

  @media (max-width: 767px) {
    .hero-image {
      height: 15vh;
      h1 {
        text-align: center;
        color: white;
        margin: auto;
        padding-top: 30px;
        line-height: 2rem;
      }
    }
  }
`;
